import { render, staticRenderFns } from "./ListGenericDocuments.vue?vue&type=template&id=0411c40e&scoped=true"
import script from "./ListGenericDocuments.vue?vue&type=script&lang=js"
export * from "./ListGenericDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0411c40e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0411c40e')) {
      api.createRecord('0411c40e', component.options)
    } else {
      api.reload('0411c40e', component.options)
    }
    module.hot.accept("./ListGenericDocuments.vue?vue&type=template&id=0411c40e&scoped=true", function () {
      api.rerender('0411c40e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Documents/Conferences/ListGenericDocuments.vue"
export default component.exports